import React, { useState } from "react";
import { useErrorHandler } from "../../../hooks";
import mainPageService from "../../../services/main-page.service";
import { InputLabel, MenuItem, Select } from "@material-ui/core";

import {
    Button,
    DialogActions,
    Divider,
} from "@material-ui/core";

import DialogTitle from "../../../components/dialog-title";


export default function ChangeSort({ close, allData, data, type="fullCard" }) {

    const [indexRow, setIndexRow] = useState(allData.findIndex(it => it.id === data.id) + 1)

    const errorHandler = useErrorHandler();

    const handleSubmit = async () => {

        let newSort = allData.filter(item => item.id !== data.id).map(item => item.id);
        newSort.splice(indexRow-1, 0, data.id);

        let op = await mainPageService.udpateSortMainPage(type, newSort);

        const { error } = op;
        if (error) return errorHandler(error);

        close(true);
    };

    return (
        <>
            <DialogTitle onClose={close}>
                تغییر ردیف
            </DialogTitle>
            <Divider />

            <div className="m-2">
                <InputLabel id="label">ردیف</InputLabel>
                <Select 
                    labelId="label" 
                    id="select" 
                    value={indexRow}
                    margin="normal"
                    variant="outlined"
                    fullWidth={true}
                    onChange={(e) => setIndexRow(e.target.value)}
                >
                    {
                        Array(allData.length).fill(1).map((item, index) => (
                            <MenuItem value={index+1}>{index+1}</MenuItem>
                        ))
                    }
                </Select>
            </div>
            <DialogActions>
                <Button onClick={close} color="primary">
                    لغو
                </Button>
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                >
                   ذخیره
                </Button>
            </DialogActions>
        </>
    );
}
